


<template>
    <div class="header">
        <div class="header-left">

            <slot name="left">

            </slot>

        </div>


        <div class="header-right">

            <slot name="right">

            </slot>


        </div>
    </div>
</template>

<script>

    export default {
        name: "Header",
        data() {
            return {
                isFullScreen: false
            }
        },
        computed: {},
        methods: {

        },
        mounted() {

        }
    }
</script>

<style lang="scss" scoped>

    .header {
        height: 64px;
        line-height: 64px;
        background-color: #ffffff;
        padding: 0 20px;
        position: relative;


        .header-left {
            display: inline-block;
            position: absolute;
            left: 20px;
        }

        .header-right {
            display: inline-block;
            position: absolute;
            right: 40px;
            line-height: 64px;

        }

    }

</style>